
const YouTubeEmbed = ({ embedUrl, page, mapSizeMod }) => {
    return (
        <iframe 
            height={page === 'tvplayerView' ? (100 + parseInt(mapSizeMod)*5) + '%' : '100%'}
            className={page.includes("playerView") ? "pvVideoBackground" : "dmVideoBackground"} 
            src={embedUrl} 
            title="DmBuddy YouTube Video Player" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; web-share" 
        />
    );
};

export default YouTubeEmbed;
